import { createReducer } from '@cheesecakelabs/boilerplate/utils'

import { LOGOUT } from '../user/actions'

import { SET_QUEUE_COUNT } from './actions'

const INITIAL_STATE = 0

export const queueCount = createReducer(INITIAL_STATE, {
  [SET_QUEUE_COUNT]: (state, { payload }) => payload,

  [LOGOUT]: () => INITIAL_STATE,
})



// WEBPACK FOOTER //
// ./src/modules/queue-count/reducers.js